module.exports = __webpack_public_path__ + "img/white-arrow-back.0bacb364.svg";